import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

export const addDraftInvestorModalInitValue = {
  data: {
    isExistentPartner: false,
    name: '',
    cif: '',
    email: '',
    partnerActualSharesCount: 0,
    selectedPartner: '',
    selectedPartnerOption: null,
    partnerNdPercent: 0,
    partnerOptions: [],
    contribution: 0,
    hasNotAdjustedContribution: false,
    proportionalityType: '',
    proportionalityPercent: 0,
    discountPercent: 0,
    hasDiscountByValuation: false,
    selectedHoldingClass: '',
    selectedHoldingClassOption: null,
    holdingClassOptions: [],
    contributionDate: null,
    file: undefined,
    documents: [],
    modalActionType: '',
    draftType: '',
    draftConditions: {
      discountPercent: 0,
      dueDate: null,
    },
    hasBeenEdited: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeIsExistentPartner(): void {},
    handleChangeName(): void {},
    handleChangeCif(): void {},
    handleChangeEmail(): void {},
    handleChangePartner(): void {},
    handleSearchPartnerByTerm: async (): Promise<
      CustomAsyncSelectOption[] | undefined
    > => undefined,
    handleChangeContribution(): void {},
    handleChangeHasNotAdjustedContribution(): void {},
    handleChangeProportionalityType(): void {},
    handleChangeProportionalityPercent(): void {},
    handleChangeDiscountPercent(): void {},
    handleChangeHasDiscountByValuation(): void {},
    handleChangeHoldingClass(): void {},
    handleChangeContributionDate(): void {},
    handleChangeFile(): void {},
    handleSearchHoldingClassByTerm: async (): Promise<
      CustomAsyncSelectOption[] | undefined
    > => undefined,
    handleSaveDraftInvestor(): void {},
  },
};
